// extracted by mini-css-extract-plugin
export default {"formField":"Vqa-z","error":"Wqa-z","disabled":"Xqa-z","fieldError":"Yqa-z","errorText":"Zqa-z","button":"_qa-z","acknowledgment":"ara-z"};